// Shared usage helpers for the CM dashboard (ENG2-2461 Counters & Limits,
// ENG2-2465 Nordic lookups usage page).
//
// The bands are the ones Customer Success works to everywhere else: the
// Global data usage page and the Slack alerts both announce at 80 / 90 / 100 %
// (ENG2-2367). Keeping one definition here means a customer can never be amber
// in one place and green in another.

// RisikaAPI writes INT max into a cap to mean "no limit". It is not a budget
// and must never be shown as a number or turned into a percentage.
export const UNLIMITED_CAP = 2147483647

export type UsageBand = 'neutral' | 'warning' | 'high' | 'exhausted'

export const isUnlimitedCap = (cap: number | null | undefined): boolean =>
  typeof cap === 'number' && cap >= UNLIMITED_CAP

// Integer percent of the cap used, or null when there is nothing to measure
// against (no cap, zero or negative). An INT-max cap is treated like any
// other number: 20 million of 2,147,483,647 is simply 0 %. Integer arithmetic
// on purpose so the dashboard rounds the same way the alerts do.
export const usagePercent = (
  used: number,
  cap: number | null | undefined,
): number | null => {
  if (typeof cap !== 'number' || cap <= 0) return null
  return Math.floor((used * 100) / cap)
}

export const usageBand = (percent: number | null): UsageBand => {
  if (percent === null) return 'neutral'
  if (percent >= 100) return 'exhausted'
  if (percent >= 90) return 'high'
  if (percent >= 80) return 'warning'
  return 'neutral'
}

// One colour per band, shared by the Usage & limits table (ENG2-2461) and the
// Nordic lookups usage page (ENG2-2465).
export const USAGE_BAND_COLOUR: Record<UsageBand, string> = {
  neutral: '#2E7D32',
  warning: '#F59E0B',
  high: '#E8710A',
  exhausted: '#D32F2F',
}
